module.exports = __webpack_public_path__ + "b58ef7ee53aea5e1355c59985e53db15.svg";